import { LOCALES } from '@/enums/locale'
import { permissionModule } from '@/enums/permission'
import i18n from '@/libs/i18n'
import type { SelectOption, TagItem } from '@/types/Common'
import type { IMe } from '@/types/User'

/*
 * People, roles and permissions in words. The labels of modules and permissions are the
 * console's (`module.<key>`, `permission.<key>`, docs/API.md → GET /permissions); a key this
 * console does not know yet — a module added to the API before the console — reads as itself.
 */
const translated = (key: string, fallback: string): string => i18n.global.te(key) ? i18n.global.t(key) : fallback

/** `dobavnice.view` → `dobavnice_view`: a dot would be a path in a message key. */
const permissionKey = (permission: string): string => permission.replace(/\./g, '_')

export const moduleLabel = (module: string): string => translated(`module.${module}`, module)

export const permissionLabel = (permission: string): string => translated(`permission.${permissionKey(permission)}`, permission)

export const permissionDescription = (permission: string): string => translated(`permission_help.${permissionKey(permission)}`, '')

/*
 * THE SIDEBAR'S SECOND LINE: the person's roles (`Me.roles`), else — no role named — the modules
 * their permissions open ("Administracija · Dobavnice").
 */
export const rolesLine = (me: IMe): string => {
    if (me.roles && me.roles.length > 0) return me.roles.map((role) => role.name).join(' · ')

    const modules = [...new Set(me.permissions.map(permissionModule))]

    return modules.length > 0 ? modules.map(moduleLabel).join(' · ') : i18n.global.t('user.no_access')
}

export const localeOptions = (): SelectOption[] => LOCALES.map((locale) => ({ label: i18n.global.t(`locale.${locale}`), value: locale }))

export const localeLabel = (locale: string): string => translated(`locale.${locale}`, locale)

export const getActiveTag = (active: boolean): TagItem => active
    ? { label: i18n.global.t('user.active'), color: 'success' }
    : { label: i18n.global.t('user.inactive'), color: 'neutral' }

/* The username rule of docs/API.md → Users. */
export const USERNAME_PATTERN = /^[a-z0-9._-]{2,40}$/

export const PASSWORD_MIN = 8
